/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { I as Input, d as defineCustomElement$1 } from './input2.js';

const CalciteInput = Input;
const defineCustomElement = defineCustomElement$1;

export { CalciteInput, defineCustomElement };

//# sourceMappingURL=calcite-input.js.map